import React from "react";
import "./Policies.css";

function Terms() {
  return (
    <div className="policy-container">
      <h1>Terms & Conditions</h1>

      <div className="policy-section">
        <h3>Terms & Conditions</h3>
        <p>
          This website is published & maintained by ATLAS TRAVEL HOUSE Journey,
          a company & existing in accordance with the laws of the Republic of
          India. With regard to the use of various services that are provided by
          ATLAS TRAVEL HOUSE Journey, the agreement between User and ATLAS
          TRAVEL HOUSE would be a binding contract. ATLAS TRAVEL HOUSE reserves
          the right to change the terms & conditions under which the services
          are offered through the website. The user shall be responsible for
          regularly reviewing the terms & conditions.
        </p>
      </div>

      <div className="policy-section">
        <h3>Payments</h3>
        <p>
          In order to purchase our tour packages or our related services through
          our website, we collect some advance payment as to hold the booking on
          a confirmed basis and the rest of the package cost should be paid 2
          days before arrival to the destination but before the commencement of
          our services, We hold the sole right to decide upon the mode of
          payment and the amount to be paid in advance. It varies according to
          the nature of the services we offer. Full payment is required to be
          sent in advance during the peak season of Chardham Tourism (X-mas, New
          Year & Festival Time) to hold the booking of hotels and resorts. ATLAS
          Travel House reserves the right to change/modify or terminate the
          offer at any time at its own discretion and without any prior notice.
          In case of unavailability in mentioned hotels, alternate accommodation
          will be arranged in a similar category hotel.
        </p>
      </div>

      <div className="policy-section">
        <h3>Mode of Payment</h3>
        <p>
          Our user friendly website provides option for overseas advance payment
          through online transfer to our company Account through net banking,
          Master/Visa debit or credit card. Foreign nationals can make payment
          through currency notes / traveler cheque or through master/visa
          American Express Credit Card. Please note that in case of payment made
          through credit card, the bank charges as applicable would be added to
          the total amount and will be paid at the same.
        </p>
      </div>
    </div>
  );
}

export default Terms;
